import React, { useEffect } from "react";
import styles from "./terms-of-use.scss";
import StaticPage from "../static-page/static-page";

export default function TermsOfUse() {
  useEffect(() => {
    function onAccordionToggle() {
      let acc, acc1;
      if (typeof window != "undefined") {
        acc = document.getElementsByClassName(styles["accordion"]);
        acc1 = document.getElementsByClassName(styles["accordion1"]);
      }

      for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          this.classList.toggle(styles["active"]);
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

      for (var i = 0; i < acc1.length; i++) {
        acc1[i].addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          this.classList.toggle(styles["active1"]);
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
    }

    onAccordionToggle();
  });

  return (
    <StaticPage>
      <div className={styles["order-con container"]}>
        &nbsp; &nbsp;
        <h2>
          <b>使用條款</b>
        </h2>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion1"]}>接受與認知</button>
        <div className={styles["panel"]} style={{ maxHeight: "560px" }}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗日用品股份有限公司（下稱「安麗」）係依據安麗網站之使用條款及其他相關規範與公告提供安麗網站（http://www.amway.com.tw）服務。本使用條款之最新內容公布於安麗網站之首頁連結，為維護您的權益，請您於使用安麗網站服務前詳細閱讀。當您使用安麗網站服務時，表示您已閱讀、瞭解並同意接受相關規定。您同意安麗有權因應營運需求，於任何時間修改或變更本使用條款之內容，並於安麗網站公告，不另個別通知。若本使用條款之任何條文修改或變更之後，您仍繼續使用安麗網站服務，即視為您已閱讀、瞭解並同意接受該項修改或變更。如果您不同意本使用條款的內容，或者您所屬的國家或地區排除本使用條款內容之任何一部分時，您應停止使用安麗網站服務。
            </p>
            <p>
              若您未滿十八歲，除應遵守上述規定之外，並應確認您的家長（或監護人）閱讀、瞭解並同意本使用條款之所有內容，方能使用或繼續使用安麗網站服務。當您使用或繼續使用安麗網站服務時，即表示您的家長（或監護人）已閱讀、瞭解並同意接受本使用條款之所有內容及其後修改或變更事項。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>隱私權保護政策</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>您的隱私將依安麗網站之「隱私權政策」受到保護與規範。</p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>帳號、密碼及安全</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>
              您加入安麗之直銷商或會員後，即有一組預設之密碼。您同意保管並維持密碼及直銷商/會員編號的機密安全是您的責任。就您利用該密碼及直銷商/會員編號所進行的一切行動，您將負完全的責任。您並同意以下事項：
            </b>
          </h5>
          <ol className={styles["C"]}>
            <li>
              您不任意將您的直銷商/會員編號與密碼提供他人使用，包含訂貨或查閱積分等。
            </li>
            <li>
              您的直銷商/會員編號與密碼遭到盜用或有其他任何資訊安全問題發生時，您將立即通知安麗。
            </li>
            <li>您使用直銷商/會員專區功能結束之後，均登出結束帳號使用。</li>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>守法義務及承諾</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>
              您承諾絕不為任何非法目的或以任何非法方式使用安麗網站之任何服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，並同意遵守所屬國家或區域之法規。若您誤觸相關法規，您同意自行負擔相關法律責任。此外，您同意並保證不得利用安麗網站服務從事侵害他人權益或違法之行為，包括但不限於：
            </b>
          </h5>
          <ol className={styles["C"]}>
            <li>
              公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或   任何形式的檔案於安麗網站上；
            </li>
            <li>
              侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利；
            </li>
            <li>違反依法律或契約所應負之保密義務；</li>
            <li>違反安麗營業守則；</li>
            <li>冒用他人名義使用安麗網站服務；</li>
            <li>傳輸或散佈電腦病毒；</li>
            <li>從事不法交易行為或張貼虛假不實、引人犯罪之訊息；</li>
            <li>販賣槍枝、毒品、禁藥、盜版軟體或其他違禁物；</li>
            <li>提供賭博資訊或以任何方式引誘他人參與賭博；</li>
            <li>濫發廣告郵件；</li>
            <li>其他安麗有正當理由認為不適當之行為。</li>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>系統中斷或故障</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗將以符合目前一般可合理期待安全性之方法及技術，維護安麗網站的正常運作，惟安麗網站服務有時可能會出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤、遭人篡改或其他經濟上損失等情形。您於使用安麗網站服務時宜自行採取防護措施。安麗對於您因使用（或無法使用）安麗網站服務而造成的損害，不負任何賠償責任。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>下載軟體或資料</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              您於安麗網站下載之任何資料，應依照著作權法及其他相關法律及規定使用。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>
          關於使用及儲存之一般措施
        </button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              您同意安麗得就安麗網站服務訂定一般措施及限制，包含但不限於電子郵件服務將保留電子郵件訊息、討論區內容管理或其他上載內容之最長期間、安麗eMail服務一個帳號當中可收發電子郵件訊息的數量限制、一個帳號可收發電子郵件訊息的最大檔案、安麗伺服器分配的最大磁碟空間，以及一般特定期間內您使用安麗網站服務之次數上限（及每次使用時間之上限）。若安麗將安麗網站服務維持或傳送之任何訊息、通訊和內容刪除或未予儲存，您同意安麗毋須承擔任何責任；您同意，安麗有權關閉長時間未使用的帳號；您亦同意，安麗有權依其自行之考量，不論通知與否，隨時變更這些一般措施及限制。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>資訊或建議</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗對於您使用安麗網站服務如eMail
              、ADSL、撥接或其他方式自行取得非安麗提供之資訊或建議，不擔保其正確性。此外，安麗將依營運需求隨時與其他公司、廠商等第三人（下稱「內容提供者」）合作或取得其同意，由其提供包括新聞或資訊等不同內容連結。為尊重智慧財產權，安麗對內容提供者所提供之內容將不做實質審查或修改，對該等內容之正確性亦不負任何責任，您宜自行判斷該等內容之正確真偽。您若認為某些內容涉及侵權或有所不實，請逕向該內容提供者反應意見。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>網站行為之責任</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>
              您公開張貼或私下傳送的資訊、資料、文字、軟體、音樂、音訊、照片、圖形、視訊、訊息或其他資料，均由您本人自負責任。此外，安麗依據法律的要求，或基於以下目的之合理必要範圍內，認定必須將您的網站行為加以保存或揭露予政府機關、司法警察或未成年人之監護人時，得加以保存及揭露：
            </b>
          </h5>
          <ol className={styles["D"]}>
            <li>遵守法令或政府機關要求之法律程序</li>
            <li>執行安麗網站使用條款</li>
            <li>回應任何侵害第三人權利之主張</li>
            <li>保護安麗及其使用者及公眾之權利、財產或個人安全。</li>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>智慧財產權的保護</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗網站資訊、程式與服務（包括但不限於：商品攝影、美術插圖、程式設計、網站畫面安排、網頁設計版式、商標、其他標示或資訊），均屬本公司或相關權利人依法擁有智慧財產權之客體，受著作權法、商標法、專利法、營業秘密法及其他智慧財產權相關法規保護。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若您欲引用或轉載前述軟體、程式或網站內容，必須依法取得安麗或其他權利人的事前書面同意。尊重智慧財產權是您應盡的義務，如有違反，您應對安麗負損害賠償責任（包括但不限於訴訟費用及律師費用等）。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>拒絕或終止使用權</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              您同意安麗得基於其自行之考量，因任何理由，包含但不限於缺乏使用，或安麗認為您已經違反安麗網站使用條款的明文規定及精神，終止您的密碼、帳號（或其任何部分）或安麗網站服務之使用。安麗亦得依其自行之考量，於通知或未通知之情形下，隨時終止安麗網站服務或其任何部分。您同意依安麗使用條款任何規定提供之安麗網站服務，無需進行事先通知即得終止，您承認並同意，安麗得立即關閉或刪除您的帳號及您帳號中所有相關資料及檔案，及停止安麗網站服務之使用。此外，您同意若安麗網站服務之使用被終止，安麗對您或任何第三人均不承擔責任。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>準據法與管轄法院</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              本使用條款之解釋與適用，以及與本使用條款有關的爭議，均應依中華民國法律處理，並以台灣台北地方法院為第一審管轄法院。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
      </div>

      <script
        async
        type="text/javascript"
        src="https://code.jquery.com/jquery-3.6.0.min.js"
        integrity="sha384-vtXRMe3mGCbOeY7l30aIg8H9p3GdeSe4IFlP6G8JMa7o7lXvnz3GFKzPxzJdPfGK"
        crossorigin="anonymous"
      ></script>
      <script
        async
        src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
        integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n"
        crossOrigin="anonymous"
      ></script>
      <script
        async
        src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
        integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
        crossOrigin="anonymous"
      ></script>
    </StaticPage>
  );
}
